<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <strong
                    >{{ partner.title }}: {{ discount_card.title }}</strong
                    >
                </CCardHeader>
                <CCardBody>
                    <PartnerDiscountCardTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Группа</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            discount_card.group ? discount_card.group.title : ''
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Приоритет</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            discount_card.priority
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            discount_card.title
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl(discount_card.picture)"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow v-if="discount_card.logo" form class="form-group">
                        <CCol sm="3" class="col-form-label">Логотип</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl(discount_card.logo)"
                                class="m2"
                                width="100" />
                        </CCol>
                    </CRow>
                    <CRow v-if="discount_card.app_title" form class="form-group">
                        <CCol sm="3" class="col-form-label">Заголовок в приложении</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            discount_card.app_title
                        }}</CCol>
                    </CRow>
                    <CRow v-if="discount_card.app_description" form class="form-group">
                        <CCol sm="3" class="col-form-label">Описание в приложении</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            discount_card.app_description
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">С анимацией</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(discount_card.animated)">
                                &nbsp;{{
                                    discount_card.enabled ? "Да" : "Нет"
                                }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow v-show="discount_card.animated" form class="form-group">
                        <CCol sm="3" class="col-form-label">Анимация</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl(discount_card.animation)"
                                class="m2"
                                width="100" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Показать на карте текущее время</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(discount_card.timed)">
                                &nbsp;{{
                                    discount_card.enabled ? "Да" : "Нет"
                                }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Ссылка на карточку партнера</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            discount_card.link
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(discount_card.enabled)">
                                &nbsp;{{
                                    discount_card.enabled ? "Да" : "Нет"
                                }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Показывать неавторизованным</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(discount_card.show_for_not_auth)">
                                &nbsp;{{
                                    discount_card.show_for_not_auth ? "Да" : "Нет"
                                }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnerDiscountCardTabLinks from '@/components/partner/PartnerDiscountCardTabLinks';

    export default {
        name: 'DiscountCard',

        components: {
            PartnerDiscountCardTabLinks,
        },

        data() {
            return {
                partner: {},
                discount_card: {},
            };
        },

        mounted() {
            const id = parseInt(this.$route.params.id);
            const discount_card_id = parseInt(this.$route.params.discount_card_id);
            Vue.axios
                .get('/partners/' + id)
                .then(resp => {
                    this.partner = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get('/discount-cards/' + discount_card_id)
                .then(resp => {
                    this.discount_card = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            pictureUrl(picture) {
                return picture ? process.env.VUE_APP_STATIC_BASE_URL + '/' + picture : '';
            },
            goBack() {
                this.$router.push({
                    path: '/partners/' + this.partner.id + '/discount-cards',
                });
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
        },
    };
</script>
